import { Box, Button, Typography } from '@material-ui/core'
import { FunctionComponent } from 'react'
import { bfutr2023palette } from './bfutr2023palette'
import { ReactComponent as CtaArrow } from './assets/Inside_CTA_arrow.svg'
import { useHistory } from 'react-router-dom'
import { StyledTopLeftQuarterCircle, StyledTopRightQuarterCircle } from './styled'
import { wordPressUrl } from 'common/globalConstants'

interface Bfutr2023TicketConfirmationDetails {
  onClose: Function
  isDevice: boolean
}

export const Bfutr2023TicketConfirmationDetails: FunctionComponent<Bfutr2023TicketConfirmationDetails> = ({
  onClose,
  isDevice
}) => {
  const { awsUrl } = process.env
  return (
    <>
      {isDevice ? (
        <Box bgcolor={bfutr2023palette.backgroundColor} mt="4em">
          <StyledTopRightQuarterCircle style={{ height: '5em', width: '3em' }} />
          <StyledTopLeftQuarterCircle style={{ height: '5em', width: '3em' }} />
          <Box display="flex" justifyContent="center" p="1em">
            <img
              src={`https://${awsUrl}.s3.amazonaws.com/media/images/logos/emails/bfutr2023_banner.png`}
              style={{ borderRadius: '10px', height: '7em', width: '100%', objectFit: 'cover', position: 'relative' }}
              alt="summit event banner"
            />
          </Box>
          <Box padding="0 1em 1em 1em">
            <Typography>
              <Box
                fontWeight="bold"
                marginBottom="0.5em"
                textAlign="center"
                style={{
                  backgroundImage: bfutr2023palette.purpleToOrangeVerticalGradient,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}
                fontFamily={`'Montserrat', sans-serif;`}
              >
                Success! You're going to 2023 BFUTR Global
                <Box>Tech Summit!!</Box>
              </Box>
            </Typography>
            <Typography variant="body1" align="center">
              <Box color={bfutr2023palette.darkText} fontFamily={`'Greycliff', sans-serif;`}>
                Get ready to connect with 20,000+ tech and business professionals, learn from industry leaders, expand
                your network and level up in your career.
              </Box>
              <Box padding="1em 0" color={bfutr2023palette.darkText} fontFamily={`'Greycliff', sans-serif;`}>
                You will receive an email with confirmation details shortly. If you don't see an email, check your
                spam/junk folder.
              </Box>
              <Box color={bfutr2023palette.darkText} padding="1em 0" fontFamily={`'Greycliff CF', sans-serif;`}>
                Join us for the BFUTR Networking Lunch, a chance to network and dine with industry leaders.
              </Box>
            </Typography>
            <Box mt="6em">
              <Button
                variant="contained"
                style={{ backgroundImage: bfutr2023palette.primaryGradient }}
                fullWidth
                onClick={() => onClose()}
              >
                <Typography variant="body1" component="div">
                  <Box fontWeight="bold" fontFamily={`'Greycliff', sans-serif;`}>
                    VIEW AGENDA
                  </Box>
                </Typography>
                <Box m="0.1em 0 0 0.75em">
                  <CtaArrow />
                </Box>
              </Button>
              <Button
                variant="contained"
                style={{ backgroundImage: bfutr2023palette.primaryGradient, marginTop: '1em' }}
                fullWidth
                onClick={() => window.location.assign(`${wordPressUrl}/meal`)}
              >
                <Typography variant="body1" component="div">
                  <Box fontWeight="bold" fontFamily={`'Greycliff', sans-serif;`} whiteSpace="nowrap">
                    BUY MEAL TICKETS
                  </Box>
                </Typography>
              </Button>
            </Box>
          </Box>
        </Box>
      ) : (
        <>
          <Typography>
            <Box
              fontWeight="bold"
              fontSize="20px"
              marginBottom="0.5em"
              textAlign="center"
              fontFamily={`'Montserrat', sans-serif;`}
              style={{
                backgroundImage: bfutr2023palette.orangeToRedVerticalGradient,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              Success! You're going to 2023 BFUTR
              <Box>Global Tech Summit!!</Box>
            </Box>
          </Typography>
          <Typography variant="body2" align="center">
            <Box color={bfutr2023palette.darkText} fontFamily={`'Greycliff CF', sans-serif;`}>
              Get ready to connect with 20,000+ tech and business professionals, learn from industry leaders, expand
              your network and level up in your career.
            </Box>
            <Box color={bfutr2023palette.darkText} padding="1em 0" fontFamily={`'Greycliff CF', sans-serif;`}>
              You will receive an email with confirmation details shortly. If you don't see an email, check your
              spam/junk folder.
            </Box>
            <Box color={bfutr2023palette.darkText} padding="1em 0" fontFamily={`'Greycliff CF', sans-serif;`}>
              Join us for the BFUTR Networking Lunch, a chance to network and dine with industry leaders.
            </Box>
          </Typography>
          <Box display="flex" justifyContent="center">
            <Button
              variant="contained"
              style={{ backgroundImage: bfutr2023palette.primaryGradient }}
              fullWidth
              onClick={() => onClose()}
            >
              <Typography variant="body1" component="div">
                <Box fontWeight="bold" fontFamily={`'Greycliff', sans-serif;`}>
                  VIEW AGENDA
                </Box>
              </Typography>
              <Box m="0.1em 0 0 0.75em">
                <CtaArrow />
              </Box>
            </Button>
            <Button
              variant="contained"
              style={{ backgroundImage: bfutr2023palette.primaryGradient, marginLeft: '1em' }}
              fullWidth
              onClick={() => window.location.assign(`${wordPressUrl}/meal`)}
            >
              <Typography variant="body1" component="div">
                <Box fontWeight="bold" fontFamily={`'Greycliff', sans-serif;`} whiteSpace="nowrap">
                  BUY MEAL TICKETS
                </Box>
              </Typography>
            </Button>
          </Box>
        </>
      )}
    </>
  )
}